import React, { useEffect, useState } from "react";
import ShowAreaIcon from "assets/svgIcons/ShowAreaIcon";
import ShowCenterIcon from "assets/svgIcons/ShowCenterIcon";
import ShowTeeIcon from "assets/svgIcons/ShowTeeIcon";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import EditIcon from "assets/svgIcons/EditIcon";
import PointIcon from "assets/svgIcons/PointOfInterestIcon";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useHookstate } from "@hookstate/core";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { SiteSetupWrapper } from "commonComponents/SideNav/subSectionNav/Map/SiteSetup/SiteSetupStyled";
import AlertModal from "commonComponents/Popup/alertModal";
import {
  FilterContainer,
  AddZoneActionWrapper,
  ConnectedStatesBtnWrapper,
  SelectionHeading
} from "commonComponents/SideNav/subSectionNav/Map/MapStyled";
import { SiteSetupAction, MAP_GLOBAL_STATES } from "globalStore/globalStore";
import CloseIcon from "../../../../../assets/svgIcons/CloseIcon";
import { siteSettingsTypes } from "constant";

export const SiteSetup = () => {
  const { t } = useTranslation();

  const [btnLocal, setBtnLocal] = React.useState({});
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [rememberClickedBtn, setRememberClickedBtn] = useState("");

  const {
    showAreas,
    showAll,
    hideAll,
    showCenterOfGreens,
    showTeeMarkers,
    showPointsOfInterest,
    editSiteSetup,
    addSiteSetup,
    addSelectType,
    holeChange,
    areaModified,
    refreshSiteSetupAreas,
  } = useHookstate(SiteSetupAction);

  const {
    siteSetupSection,
    messageActionZone,
    controlsActionZone,
    cartPathActionZone,
    geofenceActionZone,
  } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    messageActionZone.set(false);
    controlsActionZone.set(false);
    cartPathActionZone.set(false);
    geofenceActionZone.set(false);

    let temp = localStorage.getItem("mainBtnLocal");

    let BtnLocalTemp = {};
    temp = JSON.parse(temp);
    if (temp && "showAreas" in temp) {
      showAreas.set(temp.showAreas);
      holeChange.set(false);
      BtnLocalTemp = { ...BtnLocalTemp, showAreas: temp.showAreas };
    } else BtnLocalTemp = { ...BtnLocalTemp, showAreas: showAreas.get() };

    if (temp && "showCenterOfGreens" in temp) {
      showCenterOfGreens.set(temp.showCenterOfGreens);
      BtnLocalTemp = {
        ...BtnLocalTemp,
        showCenterOfGreens: temp.showCenterOfGreens,
      };
    } else
      BtnLocalTemp = {
        ...BtnLocalTemp,
        showCenterOfGreens: showCenterOfGreens.get(),
      };

    if (temp && "showTeeMarkers" in temp) {
      showTeeMarkers.set(temp.showTeeMarkers);
      BtnLocalTemp = { ...BtnLocalTemp, showTeeMarkers: temp.showTeeMarkers };
    } else
      BtnLocalTemp = { ...BtnLocalTemp, showTeeMarkers: showTeeMarkers.get() };

    if (temp && "showPointsOfInterest" in temp) {
      showPointsOfInterest.set(temp.showPointsOfInterest);
      BtnLocalTemp = {
        ...BtnLocalTemp,
        showPointsOfInterest: temp.showPointsOfInterest,
      };
    } else
      BtnLocalTemp = {
        ...BtnLocalTemp,
        showPointsOfInterest: showPointsOfInterest.get(),
      };
    setBtnLocal(BtnLocalTemp);
    addSelectType.set(siteSettingsTypes.holeArea);
  }, []);

  const handleChange = (event) => {
    addSelectType.set(event.target.value);
    showAreas.set(true);
    showTeeMarkers.set(false);
    showCenterOfGreens.set(false);
    showPointsOfInterest.set(false);

    if (event.target.value === siteSettingsTypes.siteAreaType || event.target.value === siteSettingsTypes.holeArea) {
      showAreas.set(true);
      showAll.set(true);
    }
    if (event.target.value === siteSettingsTypes.centerOfGreen) {
      showCenterOfGreens.set((prevState) => !prevState);
    }
    if (event.target.value === siteSettingsTypes.teeMarkers) {
      showTeeMarkers.set((prevState) => !prevState);
    }
    if (event.target.value === siteSettingsTypes.pointOfInterest) {
      showPointsOfInterest.set((prevState) => !prevState);
    }
  }

  const yesFuction = () => {
    setCancelConfirm(false);

    if (rememberClickedBtn === "add") {
      editSiteSetup.set(false);
      addSiteSetup.set(!addSiteSetup.get());
      showAreas.set(true);
      areaModified.set(false);
      refreshSiteSetupAreas.set(true);
    } else if (rememberClickedBtn === "edit") {
      addSiteSetup.set(false);
      editSiteSetup.set(!editSiteSetup.get());
      areaModified.set(false);
      refreshSiteSetupAreas.set(true);
    } else {
      let showAreasTemp = !showAreas.get();
      showAreas.set((prevState) => !prevState);
      showAll.set((prevState) => !prevState);
      hideAll.set(false);
      setBtnLocal({ ...btnLocal, showAreas: showAreasTemp });
      let temp = { ...btnLocal, showAreas: showAreasTemp };
      localStorage.setItem("mainBtnLocal", JSON.stringify(temp));
      holeChange.set(false);
      areaModified.set(false);
      refreshSiteSetupAreas.set(true);
    }
  }

  const handleSiteSetupArea = () => {
    if (areaModified.get()) {
      setCancelConfirm(true);
      setRememberClickedBtn("add");
    } else {
      addSiteSetup.set(!addSiteSetup.get());

      if (addSiteSetup.get()) {
        editSiteSetup.set(false);
      }

      showAreas.set(true);
    }
  }

  const handleEditSiteSetup = () => {
    if (areaModified.get()) {
      setCancelConfirm(true);
      setRememberClickedBtn("edit");
    } else {
      editSiteSetup.set(!editSiteSetup.get());
      if (editSiteSetup.get())
        addSiteSetup.set(false);
    }
  }

  const handleShowAreas = () => {
    if (areaModified.get()) {
      setCancelConfirm(true);
      setRememberClickedBtn("showArea");
    } else {
      let showAreasTemp = !showAreas.get();
      showAreas.set((prevState) => !prevState);
      showAll.set((prevState) => !prevState);
      hideAll.set(false);
      setBtnLocal({ ...btnLocal, showAreas: showAreasTemp });
      let temp = { ...btnLocal, showAreas: showAreasTemp };
      localStorage.setItem("mainBtnLocal", JSON.stringify(temp));
      holeChange.set(false);
    }
  }

  const handleShowCenterOfGreens = () => {
    let showCenterOfGreensTemp = !showCenterOfGreens.get();
    showCenterOfGreens.set((prevState) => !prevState);
    setBtnLocal({
      ...btnLocal,
      showCenterOfGreens: showCenterOfGreensTemp,
    });
    let temp = {
      ...btnLocal,
      showCenterOfGreens: showCenterOfGreensTemp,
    };
    hideAll.set(false);
    localStorage.setItem("mainBtnLocal", JSON.stringify(temp));
  }

  const handleShowTeeMarkers = () => {
    let showTeeMarkersTemp = !showTeeMarkers.get();
    showTeeMarkers.set((prevState) => !prevState);
    setBtnLocal({
      ...btnLocal,
      showTeeMarkers: showTeeMarkersTemp,
    });
    let temp = {
      ...btnLocal,
      showTeeMarkers: showTeeMarkersTemp,
    };
    hideAll.set(false);
    localStorage.setItem("mainBtnLocal", JSON.stringify(temp));
  }

  const handleShowPointsOfInterest = () => {
    let showPointsOfInterestTemp = !showPointsOfInterest.get();
    showPointsOfInterest.set((prevState) => !prevState);
    setBtnLocal({
      ...btnLocal,
      showPointsOfInterest: showPointsOfInterestTemp,
    });
    let temp = {
      ...btnLocal,
      showPointsOfInterest: showPointsOfInterestTemp,
    };
    localStorage.setItem("mainBtnLocal", JSON.stringify(temp));
    const element = document.getElementById("preview");
    element?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    hideAll.set(false);
  }

  return (
    <SiteSetupWrapper>
      {siteSetupSection.get() === true && (
        <>
          <div className="close-icon-wrapper-mobile">
            <button onClick={() => siteSetupSection.set(!siteSetupSection.get())}>
              <CloseIcon />
            </button>
          </div>

          <AddZoneActionWrapper>
            <button className={addSiteSetup.get() ? "active" : null} onClick={handleSiteSetupArea}>
              <AddIcon /> {t("Add")}
            </button>
            <button className={editSiteSetup.get() ? "active" : null} onClick={handleEditSiteSetup}>
              <EditIcon width={12} height={13} />
              {t("Edit")}
            </button>
          </AddZoneActionWrapper>

          {addSiteSetup.get() ? (
            <AddZoneActionWrapper>
              <Box sx={{ minWidth: "100%" }}>
                <FormControl fullWidth>
                  <Select
                    value={addSelectType.get()}
                    defaultValue={addSelectType.get()}
                    onChange={handleChange}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value={1}>{t("Site_Area_Type")} </MenuItem>
                    <MenuItem value={2}>{t("Hole_Area")} </MenuItem>
                    <MenuItem value={3}>{t("Center_of_Green")} </MenuItem>
                    <MenuItem value={4}>{t("Tee_Markers")} </MenuItem>
                    <MenuItem value={5}>{t("Point_of_Interest")} </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </AddZoneActionWrapper>
          ) : null}

          <FilterContainer>
            <SelectionHeading>{t("Area_Type")}</SelectionHeading>
          </FilterContainer>
          <FilterContainer>
            <ConnectedStatesBtnWrapper>
              <button className={showAreas.get() ? "active" : ""} onClick={handleShowAreas}>
                <ShowAreaIcon />
                {t("Show_Areas")}
              </button>

              <button
                className={showCenterOfGreens.get() ? "active" : ""} onClick={handleShowCenterOfGreens}>
                <ShowCenterIcon />
                {t("Show_Center_of_Greens")}
              </button>

              <button className={showTeeMarkers.get() ? "active" : ""} onClick={handleShowTeeMarkers}>
                <ShowTeeIcon color={showTeeMarkers.get() ? "#ffffff" : "#636F7C"} />
                {t("Show_Tee_Markers")}
              </button>

              <button className={showPointsOfInterest.get() ? "active" : ""} onClick={handleShowPointsOfInterest}>
                <PointIcon />
                {t("Show_Points_of_Interest")}
              </button>
            </ConnectedStatesBtnWrapper>
          </FilterContainer>
        </>
      )}
      <AlertModal
        handleOnSubmit={yesFuction}
        title={t("Confirm")}
        content={t("Discard_changes") + " ?"}
        isOpen={cancelConfirm}
        setOpenAlert={setCancelConfirm}
      />
    </SiteSetupWrapper>
  );
};
